import Box from "@mui/material/Box";
import React from "react";

const TabPanel = (props) => {
	const { children, value, index, TabPanelBoxProps, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box py={3} {...TabPanelBoxProps}>
					{children}
				</Box>
			)}
		</div>
	);
};

export default TabPanel;
